const megaphone = [
  "M8 10.05v-6.1L7.48 4H2.5a.5.5 0 0 0-.5.5V5H.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H2v.5a.5.5 0 0 0 .5.5h.3l2.01 5.36a1 1 0 0 0 .94.64.97.97 0 0 0 .7-.3l1.2-1.19a1 1 0 0 0 .19-1.15L6.16 10h1.33c.17 0 .34.03.51.05zM15.92.24a.5.5 0 0 0-.24-.2l-.01-.01h-.03C15.6.02 15.55 0 15.5 0l-.1.02-.05.01a.5.5 0 0 0-.22.14l-.02.01A10.53 10.52 0 0 1 9 3.81v6.39a10.52 10.52 0 0 1 6.11 3.62l.02.01.12.1c.02 0 .03.02.05.03a.52.51 0 0 0 .37.01.49.49 0 0 0 .22-.17l.03-.04a.48.48 0 0 0 .08-.26V.5a.48.48 0 0 0-.08-.26z"
];
export {
  megaphone
};
//# sourceMappingURL=megaphone.js.map
